import { render, staticRenderFns } from "./spotUse.vue?vue&type=template&id=968f1b46&scoped=true"
import script from "./spotUse.vue?vue&type=script&lang=js"
export * from "./spotUse.vue?vue&type=script&lang=js"
import style0 from "./spotUse.vue?vue&type=style&index=0&id=968f1b46&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968f1b46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('968f1b46')) {
      api.createRecord('968f1b46', component.options)
    } else {
      api.reload('968f1b46', component.options)
    }
    module.hot.accept("./spotUse.vue?vue&type=template&id=968f1b46&scoped=true", function () {
      api.rerender('968f1b46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/commodityFacility/detail/spotUse.vue"
export default component.exports